import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';

// Packages
import PropTypes from 'prop-types';

const CountersTable = (props) => {
	const { data } = props;

	const { global_data } = useSelector(state => state.global);

	const formatCacheKey = (key = '') => {
		let newKey = '';
		
		key.split(':').forEach((word) => { newKey += word.charAt(0).toUpperCase() + word.slice(1) + ' '	});

		return newKey;
	}

	return (
		<table className='table mt-3 mb-5'>
			<thead className='table-head'>
				<tr>
					<th scope='col'>Id</th>
					<th scope='col'>{global_data?.counters?.thKey}</th>
					<th scope='col'>{global_data?.counters?.thValue}</th>
				</tr>
			</thead>
			<tbody>
				{data.length > 0
					?	<Fragment>
							{data.map((counter, idx) => (
								<tr key={idx}>
									<td className='text-break'>{counter.counter._id.$oid}</td>
									<td>{formatCacheKey(counter.counter.cache_key)}</td>
									<td>
										{counter.data === null || counter.data === undefined
											? counter.value === null || counter.value === undefined ? 0 : counter.value
											: counter.data
										}
									</td>
								</tr>
							))}
						</Fragment>
					:	<tr>
							<td className='text-center' colSpan={3}>{global_data?.utils?.noData}</td>
						</tr>
				}
			</tbody>
		</table>
	)
}

CountersTable.propTypes = {
	data: PropTypes.array.isRequired
}

export default CountersTable;
